module.exports = __webpack_public_path__ + "img/account_back.93d532b0.png";